import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const InfoLayout = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .domains {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 504px;
    white-space: nowrap;
  }
  .expires {
    font-size: 13px;
    color: var(--label-slate-color, var(--slate));
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${semiBoldAlias()};
  }
  @media (min-width: 900px) {
    flex-direction: row;
    .expires {
      width: 275px;
      padding-left: 20px;
    }
  }
`;

export const CertificateExpanded = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
`;

export const CopyWrapper = styled.div`
  max-width: 632px;
  margin: 24px 0 40px 0;
  code {
    white-space: nowrap;
    background-color: transparent;
    color: var(--section-snow-color, var(--snow));
  }
`;

export const CopyLabel = styled.div`
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  color: var(--section-slate-color, var(--slate));
`;
